import { isDesktop } from "./screenSize";
import SwatchHelper from "./Helpers/UI/SwatchHelper";
import { delegateTriggerClick } from "./Helpers/helpers";

const breakpointsTreshlods = {
    one: 4,
    half: 2,
    medium: 8,
    large: 8,
};

export const addSwatchLabels = (productBlocks) => {
    let swatchHelper = new SwatchHelper(productBlocks);
    swatchHelper.onSwatchRendered((node, searchedNode) => {
        searchedNode.style.width = "100%";
        const swatchItems = node.querySelectorAll("li.swatch-view-item");
        const newNode = document.createElement("span");
        newNode.classList.add("swatch-color-length");
        newNode.innerHTML = swatchItems.length > 1 ? `${swatchItems.length} colors` : `${swatchItems.length} color`;
        searchedNode.parentNode.insertBefore(newNode, searchedNode.nextSibling);
        addCounter(searchedNode, swatchItems);
        modifyAriaLabelForSwatchItems(swatchItems);
    });
};

const modifyAriaLabelForSwatchItems = (swatchItems) => {
    swatchItems.forEach((item) => {
        let currentAriaLabel = item.getAttribute("aria-label") || "";
        item.setAttribute("aria-label", `Select the color ${currentAriaLabel}`);
    });
};

const addCounter = (node, swatchItems) => {
    const layoutType = getCurrentLayoutType();
    const triggerClickElementAttribute = node
        .closest("[data-handle]")
        .querySelector("a")
        .getAttribute("data-product-link");

    const hiddenSwatchCounter = document.createElement("span");
    hiddenSwatchCounter.setAttribute("data-trigger-click", `[data-product-link="${triggerClickElementAttribute}"]`);
    hiddenSwatchCounter.classList.add(
        "swatch-hidden-counter",
        "tw-hidden",
        "tw-w-12",
        "t-h-12",
        "medium-up:tw-w-8",
        "medium-up:tw-h-8",
        "tw-mr-2",
        "tw-flex",
        "tw-items-center",
        "tw-justify-center"
    );
    const visibleSwatches = breakpointsTreshlods[layoutType];

    let lastSwatches = 0;
    if (swatchItems.length > visibleSwatches) {
        hiddenSwatchCounter.classList.remove("tw-hidden");
        lastSwatches = swatchItems.length - visibleSwatches;
    }
    hiddenSwatchCounter.innerHTML = swatchItems.length > 0 ? `+ ${lastSwatches}` : ``;
    node.append(hiddenSwatchCounter);
    delegateTriggerClick(hiddenSwatchCounter);
};

export const rebuildExtraCounters = () => {
    const swatchNodes = document.querySelectorAll("ul.swatch-view");

    if (swatchNodes.length > 0) {
        swatchNodes.forEach((swatchNode) => {
            const hiddenSwatchCounter = swatchNode.querySelector(".swatch-hidden-counter");
            const swatchItems = swatchNode.querySelectorAll("li.swatch-view-item");

            if (swatchNode) {
                let lastSwatches = 0;
                const visibleSwatches = breakpointsTreshlods[getCurrentLayoutType()];

                if (swatchItems.length > visibleSwatches) {
                    hiddenSwatchCounter.classList.remove("tw-hidden");
                    lastSwatches = swatchItems.length - visibleSwatches;
                } else {
                    hiddenSwatchCounter.classList.add("tw-hidden");
                }
                hiddenSwatchCounter.innerHTML = swatchItems.length > 0 ? `+ ${lastSwatches}` : ``;
            }
        });
    }
};

export const getSwatchWrappers = () => {
    return document.querySelectorAll("[data-swatch-wrapper]");
};

const getCurrentLayoutType = () => {
    let layoutType = "one";
    const layoutTypeEl = document.querySelector("[data-grid-layout]");
    const homeLayoutTypes = document.querySelectorAll("[data-grid-home-layout]");

    if (layoutTypeEl) {
        layoutType = layoutTypeEl.dataset.gridLayout;
    } else if (isDesktop()) {
        layoutType = "medium";

        homeLayoutTypes.forEach((homeLayoutType) => {
            homeLayoutType.setAttribute("data-grid-home-layout", "medium");
        });
    }

    return layoutType;
};
